import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";

import { CampaignContactUploadArgs } from "~frontend/__generated__/graphql";

import { CampaignForEditor } from "../../types";
import CsvUploadForm from "./CSVUploadForm";

export default function CsvUploadImport({
  campaign,
  readOnly,
  previousJobArgs,
  resetContactSourceSettings,
}: {
  campaign: CampaignForEditor;
  readOnly: boolean;
  previousJobArgs?: CampaignContactUploadArgs;
  resetContactSourceSettings: (() => void) | null;
}): ReactElement {
  if (readOnly) {
    return (
      <Box>
        <Typography>
          Uploaded {previousJobArgs?.upload?.fileName || "unknown file"}
        </Typography>
        <Typography>
          Phone number column: {previousJobArgs?.phoneNumberColumn}
        </Typography>
      </Box>
    );
  }

  return (
    <CsvUploadForm
      campaign={campaign}
      resetContactSourceSettings={resetContactSourceSettings}
    />
  );
}
